import { API_BASE } from "./config";

/**
 * Call a Function App query endpoint with the user's ID token.
 */
async function apiFetch(path, token, params = {}) {
  const url = new URL(`${API_BASE}/${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v);
  });

  const res = await fetch(url.toString(), {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`API error ${res.status}: ${err}`);
  }
  return res.json();
}

// ── Activity feed ────────────────────────────────────────────────────────────
export async function getActivityFeed(token, { actorEmail, eventType, days = 7, take } = {}) {
  return apiFetch("queryActivities", token, { actorEmail, eventType, days, take });
}

export async function getActivityMeta(token) {
  return apiFetch("queryActivityMeta", token);
}

// ── Prompts (OTel) ───────────────────────────────────────────────────────────
export async function getPrompts(token, { keyword, userEmail, days = 7, take } = {}) {
  return apiFetch("queryPrompts", token, { keyword, userEmail, days, take });
}

export async function getPromptTrace(token, promptId) {
  return apiFetch("queryPromptTrace", token, { promptId });
}

// ── Chats ────────────────────────────────────────────────────────────────────
export async function getChats(token, { keyword, actorEmail, days = 30 } = {}) {
  return apiFetch("queryChats", token, { keyword, actorEmail, days });
}

export async function getChatMessages(token, chatId) {
  return apiFetch("queryChatMessages", token, { chatId });
}

// ── Analytics ────────────────────────────────────────────────────────────────
export async function getAnalytics(token, days = 7) {
  return apiFetch("queryAnalytics", token, { days });
}
